
const VERSION = {
  SHA1:'db6c40f0ee5257ee986cdf2872fb7d201f92f982',
  VERSION:2344,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
